import { createApp } from 'vue'
import { createStore } from 'vuex'
import App from './App.vue'
import router from './router'
import {DateTime} from 'luxon'

const store = createStore({
    state: {
        id_form:''
    },
    mutations: {
        set_id_form: (state,id)=>{
            state.id_form = id;
        }
    }
});

const app = createApp(App);
app.config.globalProperties.$filters = {
    money(value,lang){
        var vtype = "";
        switch(lang){
            case "fr-FR":
                vtype="EUR";
                break;
            case "pl-PL":
                vtype="PLN";
                break;
            case "en-GB":
                vtype="GBP";
                break;
            case "en-US":
                vtype="USD";
                break;
            default:
                vtype="EUR";
                break;
        }

        var formatter = new Intl.NumberFormat(lang, {style: 'currency',currency: vtype,minimumFractionDigits: 2,maximumFractionDigits:2});
        try{
            return formatter.format(value);
        }catch{
            return value;
        }
    },
    number(value,lang){
        var formatter = new Intl.NumberFormat(lang, {style: 'decimal',minimumFractionDigits: 2,maximumFractionDigits:2});
        try{
            return formatter.format(value);
        }catch{
            return value;
        }
    },
    mdate(value,lang){
        return DateTime.fromSQL(value,{locale:lang}).toLocaleString(DateTime.DATE_SHORT);
    },
    mtime(value,lang){
        return DateTime.fromSQL(value,{locale:lang}).toLocaleString("HH:mm");
    },
    mdatetime(value,lang){
        return DateTime.fromSQL(value,{locale:lang}).toLocaleString("DD/MM/YYYY HH:mm");
    },
    image(value){
        try{
            var binary = '';
          var bytes = new Uint8Array(value);
          var len = bytes.byteLength;
          for (let i = 0; i < len; i++) {
              binary += String.fromCharCode(bytes[i]);
          }
          return 'data:image/png;base64,'+btoa(binary);
        }catch(error){
            return "";
        } 
    }
}
app.use(store);
app.use(router);
app.mount('#app');